import { render, staticRenderFns } from "./BatchCategory.vue?vue&type=template&id=10da6291&scoped=true"
import script from "./BatchCategory.vue?vue&type=script&setup=true&lang=ts"
export * from "./BatchCategory.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10da6291",
  null
  
)

export default component.exports